import { ChangeDetectorRef, Component } from '@angular/core';
import { BasePlugin } from '../../base-plugin.component';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    templateUrl: './road-surface.component.html',
    standalone: false
})
export class InstallationRoadSurfacePluginComponent {
  public surfaceType: any;
  public config: any;
  public editRoute = ['installation', 'roadsurface', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.surfaceType = this.config.SurfaceType;
  }
}
PluginComponent.plugins['installationroadsurface'] = InstallationRoadSurfacePluginComponent;
